import React from 'react'
import { JobWizard } from 'sprockets_react/job_wizards/registries'

const CategoryInput = React.createClass({
  componentDidMount: function() {
    this.onAutocomplete()
  },

  handleSelectedCategory: function(event, selected) {
    JobWizard.Emitter.emit('job:wizard:categorySelected', event, selected)
    this.props.handleSelectedCategory && this.props.handleSelectedCategory(event, selected)
  },

  onAutocomplete: function() {
    SS.taskAutocomplete(`.category-${this.props.guId}`, this.handleSelectedCategory, this.props.preferKeywords, this.props.resultCallback)
  },

  renderCategory: function() {
    return(
      <input type="text"
        className={`form-control category-${this.props.guId} ${this.props.inputClass}`}
        name="category"
        data-category-id={this.props.categoryId}
        id={`category-${this.props.guId}`}
        placeholder={this.props.placeholder || 'e.g. Tiler, Cleaner, Electrician'}
        value={this.props.category}
        onChange={this.props.handleCategoryChange}
      />
    )
  },

  render: function() {
    return this.renderCategory()
  }
})

export default CategoryInput
